var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BaseAlert, {
    attrs: {
      color: "text-warning",
      text: _setup.t(
        "Ознакомьтесь с ограничениями на приём у врача в этой клинике",
        _setup.options
      ),
      "link-text": _setup.t("Смотреть", _setup.options),
    },
    on: {
      "click:link": function ($event) {
        return _setup.emit("open-appointment-restrictions")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }